import { ApiResponseError } from "../client-core/api-response-models";

//Wraps ApiResponseError for validation display purposes
export class ValidationMessage{
    private _messages: Array<string>;

    constructor(
        private apiResponseErrors: Array<ApiResponseError>,
        private showInBox: boolean = false,
        private title: string = "Error",
        private type:  string = "danger",
        private dismissAfterSeconds: number = 5
    ) {
        this._messages = new Array<string>();

        if (this.apiResponseErrors && this.apiResponseErrors.length) {
            for (let i = 0; i < this.apiResponseErrors.length; i++) {
                for (let j = 0; j < this.apiResponseErrors[i].errors.length; j++) {
                    this._messages.push(this.apiResponseErrors[i].errors[j]);
                }
            }
        }
    }

    get errors(): Array<ApiResponseError> {
        return this.apiResponseErrors;
    }

    get displayType() : string {
        return this.type;
    }
    
    get displayInBox(): boolean {
        return this.showInBox;
    }

    get displayTitle(): string {
        return this.title;
    }

    get hidefterSeconds(): number {
        return this.dismissAfterSeconds;
    }

    get messages(): string[] {
        return this._messages;
    }

    public static create(): ValidationMessage {
        let message = new ValidationMessage(null);
        message.setDismissAfterSeconds(5)
            .setTitle("Message")
            .isSuccess();
        return message;
    }

    public setDismissAfterSeconds(seconds: number): ValidationMessage {
        this.dismissAfterSeconds = seconds;
        return this;
    }

    public setTitle(title: string): ValidationMessage {
        this.title = title;
        return this;
    }

    public setDisplayInBox(inBox: boolean): ValidationMessage {
        this.showInBox = inBox;
        return this;
    }

    public pushMessage(message: string): ValidationMessage {
        this._messages.push(message);
        return this;
    }

    public setError(apiResponseErrors: Array<ApiResponseError>): ValidationMessage {

        if (apiResponseErrors && apiResponseErrors.length) {
            for (let i = 0; i < apiResponseErrors.length; i++) {
                for (let j = 0; j < apiResponseErrors[i].errors.length; j++) {
                    this._messages.push(apiResponseErrors[i].errors[j]);
                }
            }
        }

        return this;
    }

    public isDanger(): ValidationMessage  {
        this.type = "danger";
        return this;
    }

    public isSuccess() : ValidationMessage {
        this.type = "success";
        return this;
    }

    public isWarning(): ValidationMessage  {
        this.type = "warning";
        return this;
    }
}


// WEBPACK FOOTER //
// ./src/app/validation/ValidationMessage.ts